module.exports = __webpack_public_path__ + "img/587.dede05ba.jpg";